export const readymade ={
    mainPathName:"readymade",
    addBrand:"addBrand"
}